import React, { useEffect, useState } from 'react';
import { apiHandler } from '../../../api/apihandler';
import { FOLLOWER_LIST } from '../../../api/constants';
import { apiSucceeded, getAvatarColor, getInitials } from '../feed/feedUtils';
import PeopleYouMayKnowWidget from '../../../components/nemonto/PeopleYouMayKnowWidget';
import MyStatsWidget from '../../../components/nemonto/MyStatsWidget';
import EmptyState from '../../../components/nemonto/EmptyState';
import './social-list-page.css';

const PersonAvatar = ({ photo, name }) => {
  if (photo) return <img src={photo} alt={name} className="nmsl-avatar" />;
  return (
    <div className="nmsl-avatar" style={{ background: getAvatarColor(name || 'User') }}>
      {getInitials(...(name || 'User').split(' '))}
    </div>
  );
};

const FollowersPage = () => {
  const [followers, setFollowers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await apiHandler(FOLLOWER_LIST, 'POST', { page: 1, limit: 100 });
        if (apiSucceeded(res)) setFollowers(res?.data?.data?.followers?.data || []);
      } catch (e) { console.error(e); }
      finally { setLoading(false); }
    })();
  }, []);

  return (
    <div className="nmsl-layout">
      <div className="nmsl-main">
        <div className="nmsl-page-header">
          <div className="nmsl-header">
            <h3 className="nmsl-title">Followers</h3>
            {followers.length > 0 && <span className="nmsl-count-pill">{followers.length}</span>}
          </div>
          <p className="nmsl-subtitle">Everyone who's following your kitchen.</p>
        </div>

        <div className="nmsl-main-body">
          {loading && <p className="nmsl-loading">Loading…</p>}
          {!loading && followers.length === 0 && (
            <EmptyState icon="group" title="No followers yet" sub="Share your recipes to start building a following." />
          )}

          {!loading && followers.length > 0 && (
            <div className="nmsl-grid">
              {followers.map((f) => {
                const user = f?.follower;
                const name = `${user?.first_name || ''} ${user?.last_name || ''}`.trim() || 'User';
                return (
                  <div key={f.id} className="nmsl-card">
                    <PersonAvatar photo={user?.user_setting?.photo} name={name} />
                    <div className="nmsl-body">
                      <div className="nmsl-name">{name}</div>
                      <div className="nmsl-sub">{f?.followers_count ?? 0} followers · {f?.followings_count ?? 0} following</div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>

      <aside className="nmsl-rail">
        <PeopleYouMayKnowWidget />
        <MyStatsWidget />
      </aside>
    </div>
  );
};

export default FollowersPage;
